export default "__VITE_ASSET__C4xws0KK__"